import { useState, useEffect } from "react";
import FlatList from "flatlist-react";
import { useTranslation } from "react-i18next";
import * as Action from "@mywvglobal-shared/mywv-shared/action/worldAction";
import { useDispatch, useSelector } from "react-redux";
import SingleChildMarkerView from "../../organism/singleChildMarkerView";
import SearchViewComponent from "../../molecule/searchView";
import SEARCHWHITE from "../../../images/search-icon-grey.svg";
import Modal from "react-bootstrap/Modal";
import { ChildList, ChildListContainer, ChildSearchCloseIcon, RegionName } from "./childSearch";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../../utilities/tokenizer";
import { diffYMDHMS } from "../../../utilities/dateUtilities";
import {capitalizeFirstLetter} from "../../../utilities/inputSanitizer";
import {getCountryName} from "../../../utilities/countryUtilities";
import { SELECTED_SO_CODE_FINO } from "../../../constants/soCode";
const styles = {
  iconsearchstyle: {
    height: "15px",
    width: "15px",
    marginLeft: "10px",
  },
  inputstyle: {
    color: "#000",
    fontSize: "14px",
    fontFamily: "Lato-Bold",
    paddingVertical: 0,
  },
  searchImg: {
    marginLeft: "10px",
  },
  noDataViewStyles: { flex: 1, justifyContent: "center", alignItems: "center" },
  noDataStyles: {
    color: "#000",
    textAlign: "center",
    fontFamily: "Lato-Bold",
  },
}

function ChildSearchView(props) {

  const { t } = useTranslation();
  const { worldReducer, persistItemsReducer } = useSelector((state) => state);
  const childGroupList = props?.childGroupList;
  const isFromGroup = props?.isFromGroup;
  const groupTitle = props?.subRegionName;
  const [filteredChildList, setFilteredChildList] = useState(null);
  const [originalChildList, setOriginalChildList] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isFromGroup) {
      if (childGroupList && childGroupList.length > 0) {
        setFilteredChildList(childGroupList);
        setOriginalChildList(childGroupList);
      }
    } else if (worldReducer?.childList) {
      setFilteredChildList(worldReducer?.childList);
      setOriginalChildList(worldReducer?.childList);
    }
  }, [childGroupList]);

const searchChildListValue = (searchText, childListValue = []) => {
  const query = searchText?.trim().toLowerCase();
  if (!query) return childListValue;

  return childListValue?.filter(({ childFirstName = "", projectName = "", countryName = "" }) =>
    [childFirstName, projectName, countryName].some(field =>
      field.toLowerCase().includes(query)
    )
  );
};


  const searchChildList = (searchtext) => {
    if (isFromGroup) {
      setFilteredChildList(
        searchChildListValue(searchtext, originalChildList),
      );
    } else {
      setFilteredChildList(
        searchChildListValue(searchtext, originalChildList),
      );
    }
  };

  const onChildClick = (item) => {
    props?.setVisibility();
    if (
      /\/(pastSponsoredChild|drop-child-profile)/.test(window.location.pathname)
    ) {
      if (props?.clickedButton === "connect") {
        navigate(`/connect/${encrypt(item.childCode)}`, {
          state: { navigateFrom: "station" },
        });
      } else if (props?.clickedButton === "give") {
        navigate(`/sendAGift/${encrypt(item.childCode)}`, {
          state: { navigateFrom: "station" },
        });
      }
    } else if (item?.revealDate) {
      const diffObj = diffYMDHMS(new Date(item?.revealDate), new Date());
      if (diffObj?.days < 0) {
        navigate("/chosen-children/");
      } else {
        navigate(`/chosen-layout/${item?.chosenCorrelationID}`);
      }
    } else {
      const param = {
        selectedChildValues: item,
      };
      dispatch(Action.saveChildDetails(param));
      navigate(`/communityhomeview/${encrypt(item.childCode)}`);
    }
  };

  const renderListItem = (item, index) => {
    return(
    <ChildList key={index} onClick={() => onChildClick(item)} className="child-list">
      <SingleChildMarkerView
        isFino={persistItemsReducer?.selectedSOData?.soCode === SELECTED_SO_CODE_FINO}
        childValue={item}
        childProjectCountry={`${item.projectName}, 
        ${getCountryName(item?.countryName,
          item?.countryNameOtherLanguages,
          persistItemsReducer?.selectedSOData?.soLanguageCultureCode
        )}`}
        childSearch={true}
        clickedButton={props?.clickedButton}
      />
    </ChildList>
  )
}

  const searchIcon = <img src={SEARCHWHITE} style={styles.searchImg} alt="" />;

  const getTitleContent = () => {
  if (groupTitle) return groupTitle;
  if (/\/drop-child-profile/.test(window.location.pathname)) {
    return capitalizeFirstLetter(t("ActiveSponsorships"));
  }
  return null;
};

const title = getTitleContent() && <RegionName>{getTitleContent()}</RegionName>;
  return (
    <Modal
      className="child-search-popup"
      show={props?.isVisible}
    >
      <ChildSearchCloseIcon onClick={() => {
        props?.setVisibility();
        searchChildList("");
      }}>
        X
      </ChildSearchCloseIcon>
      <div>
        {title}
        <SearchViewComponent
          searchCallBack={(searchtext) => searchChildList(searchtext)}
          placeholderText={t("SearchName")}
          enableSerach
          placeholderTextColor="#000"
          icon={searchIcon}
          inputstyle={styles.inputstyle}
        />
        <ChildListContainer>
          {(filteredChildList && filteredChildList.length > 0)
            ?
            <FlatList
              list={filteredChildList}
              renderItem={renderListItem}
              keyExtractor={(item) => item.childCode}
              numColumns={2}
              showsVerticalScrollIndicator={false}
              keyboardShouldPersistTaps="handled"
            />
            :
            <div style={styles.noDataViewStyles}>
              <span style={styles.noDataStyles}>{t("NoResults")}</span>
            </div>
          }
        </ChildListContainer>
      </div>
    </Modal>
  );
}

export default ChildSearchView;
